import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@environments/environment';
import { RoutePaths } from '@global/routePaths';
import { GlobalError, LEVEL } from './global-error';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private readonly router: Router;
  // Error handling is important and needs to be loaded first.
  // Because of this we should manually inject the services with Injector.
  constructor(private readonly injector: Injector) {
    this.router = this.injector.get(Router);
  }

  handleError(error: GlobalError) {
    this.printLog(error);
  }

  private printLog(error: GlobalError) {
    switch (error && error.level) {
      case LEVEL.debug:
        if (!environment.production) {
          // tslint:disable-next-line: no-console
          console.debug(error);
        }
        break;
      case LEVEL.warn:
        if (!environment.production) {
          console.warn(error);
        }
        break;
      case LEVEL.info:
        if (!environment.production) {
          // tslint:disable-next-line: no-console
          console.info(error);
        }
        break;
      default:
        if (error.message.includes('ExpressionChangedAfterItHasBeenCheckedError')) {
          if (!environment.production) {
            console.warn(error);
          }
          return;
        }
        if (!environment.production) {
          console.error(error);
        }
        error.url.includes('/maintenance')
          ? this.router.navigateByUrl(RoutePaths.GENERIC_ERROR.route, {})
          : this.router.navigateByUrl(RoutePaths.GENERIC_ERROR.route, { state: { continueToErrorPage: true } });
    }
  }
}
